module.exports = __webpack_public_path__ + "img/profile-add.982833a4.svg";